<router-outlet></router-outlet>
<a (click)="openAiModal()"  >
  <div class="chatbot-button" [class.chatbot-button-hide]=" isRouteChatbot " >
    <span>{{labels.lblAiChat}}</span>
    <img src="/assets/images/chatbot.png" alt="Chatbot" width="70" height="60">
  </div>
</a>


